import TemplateView from '../../../TemplateView'

export default class WelcomeScreenLightboxFooter extends TemplateView
{
    templateHtml() {
        return `<div></div>`
    }

    getCommitBtnEl() {
        return this.find('.cancelBtn')
    }

    getCancelBtnEl() {
        return this.find('.cancelBtn')
    }
}



// WEBPACK FOOTER //
// ./web/js/support/welcomeScreen/components/WelcomeScreenLightboxFooter.js